import React, { FC, useEffect, useRef } from 'react';
import { FormSpy, useForm } from 'react-final-form';
import { getIn } from 'final-form';

type WhenTwoFieldChangesProps = {
  name: string;
  nameFrom: string;
  nameTo: string;
  calculateNewValue: (valueFrom: string, valueTo: string) => string;
};

const WhenTwoFieldChanges: FC<WhenTwoFieldChangesProps> = ({
  name,
  nameFrom,
  nameTo,
  calculateNewValue,
}) => {
  const { change } = useForm();

  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  });

  return (
    <FormSpy
      onChange={({ values }) => {
        if (!isFirstRender.current) {
          const valueFrom = getIn(values, nameFrom);
          const valueTo = getIn(values, nameTo);
          const oldValue = getIn(values, name);
          const newValue = calculateNewValue(valueFrom, valueTo) || '';

          const isChangedValue = oldValue !== newValue;

          if (valueFrom && valueTo && isChangedValue) {
            change(name, newValue);
          } else if ((!valueFrom || !valueTo) && oldValue) {
            change(name, '');
          }
        }
      }}
    />
  );
};

export default WhenTwoFieldChanges;
